export default __webpack_public_path__ + "static/media/B2C.38e06d12.png";